import {Box, styled} from '@mui/material';

export const AppointmentDetailsContentWrapper = styled(Box)`
	padding: 16px;

	${({theme}) => theme.breakpoints.up('sm')} {
		padding: 32px;
	}
`;
